var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:_vm.$style.statusVacation},[_vm._v("休暇中")])
}
var staticRenderFns = []

export { render, staticRenderFns }